module.exports = __webpack_public_path__ + "static/media/image-3.4f55071d.png";